import { MAX_INVENTORY_QUANTITY_TO_SET } from '../components/modals/BulkEditInventoryQuantitiesModal/constants';

export const editInvetoryQuantitiesUtils = {
  getQuantityValidationWarnings,
};

function getQuantityValidationWarnings(quantity) {
  const validationWarnings = [];
  if (quantity === null || Number.isNaN(Number(quantity))) {
    validationWarnings.push('Input must be a number');
  }
  if (quantity > MAX_INVENTORY_QUANTITY_TO_SET) {
    validationWarnings.push(`quantity exceeds ${MAX_INVENTORY_QUANTITY_TO_SET}`);
  }
  if (quantity !== Math.floor(quantity)) {
    validationWarnings.push('quantity is not a whole number');
  }
  return validationWarnings;
}
